// extracted by mini-css-extract-plugin
export default {"regenAll":"mel-regen-button_regenAll__ZjuvL"};